import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/config/routes';

export const LoginPage = () => <Navigate to={ROUTES.landing} replace />;
